export const COPY_NAME_PREFIX = 'Copy - ';

export function buildCopyTemplateName(name) {
  return `${COPY_NAME_PREFIX}${String(name ?? '')}`;
}
